import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DirectivesModule } from '../directives.module';
import { EmojiButtonComponent } from '../emoji-button/emoji-button.component';
import { WidthRestrictedContainerModule } from '../width-restricted-container/width-restricted-container.module';
import { MoodCheckQuestionComponent } from './mood-check-question.component';

@NgModule({
  declarations: [MoodCheckQuestionComponent],
  imports: [
    CommonModule,
    IonicModule,
    WidthRestrictedContainerModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    EmojiButtonComponent
  ],
  exports: [MoodCheckQuestionComponent]
})
export class MoodCheckQuestionModule {}
